<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <vue-tel-input
                    v-model="internalValue"
                    :onlyCountries="countries"
                    :dynamicPlaceholder="true"
                    :defaultCountry="defaultCountry"
                    mode="international"
                    :inputOptions="{ showDialCode: false }"></vue-tel-input>
                <!--
                <input type="text" value="" v-model="internalValue" :placeholder="placeholder" :readonly="readOnly" :maxlength="maxlength"/>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>-->
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','suffix','lang','required','readonly','maxlength'],
        data: function () {
            return {
                defaultCountry: null,
                internalValue: '',
                langClass:"",
                phone: null,
                countries: ['CH','FR','DE','IT','ES']
            }
        },
        created: function() {
            this.defaultCountry = this.$store.state.scope.country_id;
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Phone.vue